import { Locale } from "src/translations"

type PagePaths =
  | "home"
  | "account"
  | "bookings"
  | "orders"
  | "service"
  | "shop"
  | "registration"
  | "shopDetails"
  | "cart"

const de = {
  home: "/",
  account: "/de/konto/",
  bookings: "/de/buchungsdetails/",
  orders: "/de/meine-serviceanfragen/",
  service: "/de/service/",
  shop: "/de/store-de/",
  shopDetails: "/de/produkt-details/",
  cart: "/de/warenkorb/",
  registration: "/de/standanmeldungen/",
}

const en = {
  home: "/en/homepage/",
  account: "/en/account/",
  bookings: "/en/booking-details/",
  orders: "/en/orders/",
  service: "/en/service-2/",
  shop: "/en/store-en/",
  shopDetails: "/en/product-details/",
  cart: "/en/my-cart/",
  registration: "/en/stand-registration/",
}

export const getPath = (locale: Locale, path: PagePaths) => {
  const paths = locale === "de" ? de : en
  return paths[path]
}
